import React, {Component} from 'react';
import './topBtn.scss';
import $ from 'jquery';
// 返回顶部按钮
class TopBtn extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showTop: false
        };

    }

    render() {
        return (
            this.state.showTop ? (
                <div className="top-btn" onClick={this.top.bind(this)}></div>
            ) : ('')
        );
    }

    componentDidMount() {
        this.initTopBtn();
    }
    componentWillUnmount(){
        this.setState = (state,cancelIdleCallback)=>{return}
    }

    initTopBtn() {
        const {type} = this.props;
        if (type === 1) {
            $(window).scroll(() => {
                var distance = $('html').scrollTop();//PC调试要改成html，移动端为html
                var dis = $('body').scrollTop();
                if (distance > 300 || dis > 300) {
                    this.setState({
                        showTop: true
                    })
                } else if (distance < 300 || dis < 300) {
                    this.setState({
                        showTop: false
                    })
                }
            })
        } else {
            $('.scroll').scroll(() => {
                var distance = $('.scroll').scrollTop();//PC调试要改成html，移动端为html
                if (distance > 300) {
                    this.setState({
                        showTop: true
                    })
                } else if (distance < 300) {
                    this.setState({
                        showTop: false
                    })
                }
            })
        }
    }

    top() {
        const {type} = this.props;
        if (type === 1) {
            $('html,body').animate({scrollTop: '0px'}, 200);
        } else {
            $('.scroll').animate({scrollTop: '0px'}, 200);
        }

    }
}

export default TopBtn;


// WEBPACK FOOTER //
// ./src/components/TopBtn/topBtn.js